import moment from 'moment'

export default (value) => {
    return new moment(value).format('YYYY-MM-DD');
}
